import { categories } from "@/mocks/homeData";

interface ColumnsSectionProps {
  onSelect: (id: string) => void;
}

export default function ColumnsSection({ onSelect }: ColumnsSectionProps) {
  const go = (id: string) => {
    onSelect(id);
    document.getElementById("latest")?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section id="columns" className="bg-background-100/70">
      <div className="mx-auto max-w-7xl px-4 py-12 md:px-6 md:py-16">
        <div className="flex flex-col gap-3 md:flex-row md:items-end md:justify-between">
          <div>
            <span className="inline-flex items-center gap-1.5 text-xs font-semibold uppercase tracking-widest text-primary-600">
              <i className="ri-focus-3-line" />
              Track Columns
            </span>
            <h2 className="mt-2 font-heading text-2xl font-black text-foreground-950 md:text-3xl">
              六条追踪线索
            </h2>
            <p className="mt-1 max-w-2xl text-sm text-foreground-700">
              按你最关心的身份切面订阅观察，每条栏目下都有持续跟进的第一手动态与拆解。
            </p>
          </div>
          <p className="text-xs text-foreground-500">共收录 {categories.reduce((n, c) => n + c.count, 0)}+ 条观察</p>
        </div>

        <div className="mt-7 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {categories.map((c, i) => (
            <button
              key={c.id}
              type="button"
              onClick={() => go(c.id)}
              className={`group flex flex-col rounded-2xl border p-5 text-left transition-all md:p-6 ${
                i % 3 === 0
                  ? "border-primary-200 bg-primary-50/60 hover:border-primary-300"
                  : i % 3 === 1
                  ? "border-accent-200 bg-accent-50/60 hover:border-accent-300"
                  : "border-secondary-200 bg-secondary-50/60 hover:border-secondary-300"
              }`}
            >
              <div className="flex items-center justify-between">
                <span
                  className={`flex h-12 w-12 items-center justify-center rounded-2xl text-xl transition-transform group-hover:scale-110 ${
                    i % 3 === 0
                      ? "bg-primary-500 text-background-50"
                      : i % 3 === 1
                      ? "bg-accent-500 text-background-50"
                      : "bg-secondary-500 text-background-50"
                  }`}
                >
                  <i className={c.icon} />
                </span>
                <span className="rounded-full bg-background-50/70 px-3 py-1 text-xs font-semibold text-foreground-700 ring-1 ring-background-200">
                  {c.count} 条
                </span>
              </div>
              <h3 className="mt-4 font-heading text-lg font-bold text-foreground-950">{c.name}</h3>
              <p className="mt-1.5 flex-1 text-sm leading-relaxed text-foreground-700">{c.desc}</p>
              <span className="mt-4 inline-flex items-center gap-1 text-sm font-semibold text-primary-700">
                进入栏目
                <i className="ri-arrow-right-line transition-transform group-hover:translate-x-1" />
              </span>
            </button>
          ))}
        </div>
      </div>
    </section>
  );
}